import './AuthenticationStyles.css'

export default function Authentication() {
    return (
        <div className='authentication__container'>
            <div className='authentication__explanation'>
                I am planning on adding authentication to this application in the future so that users can store books in their library. However, as I am applying to jobs while also using this project to show my skillset, I wanted to get a minimum viable product out there :).
                <br />
                <br />
                -Zoe
            </div>
        </div>
    )
}
